export default "__VITE_ASSET__4e889b7e__"